import React from "react";
import { NeighborhoodMapProperty } from "@cma/presentation-generation-logic";
import _GoogleMapReact, {
  Props as GoogleMapReactProps,
} from "google-map-react";
import { MapMarker } from "./MapMarker";

// Type assertion to fix React 18 compatibility with google-map-react
const GoogleMapReact =
  _GoogleMapReact as unknown as React.ComponentClass<GoogleMapReactProps>;

type GoogleMapProps = {
  properties: NeighborhoodMapProperty[];
  onMarkerClick: (
    e: React.MouseEvent<HTMLDivElement>,
    properties: NeighborhoodMapProperty[],
  ) => any;
};

export const GoogleMap = ({ properties, onMarkerClick }: GoogleMapProps) => {
  const groupedProperties: { [key: string]: NeighborhoodMapProperty[] } = {};

  properties?.forEach((p) => {
    const key = `lat=${p.lat.toFixed(4)}&long=${p.lng.toFixed(4)}`;
    groupedProperties[key] = (groupedProperties[key] ?? []).concat([p]);
  });

  return (
    <GoogleMapReact
      options={{
        clickableIcons: false,
        fullscreenControl: false,
      }}
      onGoogleApiLoaded={(api) => {
        const bounds = new api.maps.LatLngBounds();
        properties?.forEach(({ lat, lng }) => {
          bounds.extend({ lat, lng });
        });
        api.map.fitBounds(bounds, 50);
      }}
      bootstrapURLKeys={{
        key: process.env.GOOGLE_MAPS_API_KEY ?? "",
        libraries: ["places", "geometry"],
        id: "google-map-view",
      }}
      yesIWantToUseGoogleMapApiInternals
      defaultCenter={{
        lat: 37.773972,
        lng: -122.431297,
      }}
      defaultZoom={11}
      style={{ width: "100%" }}
    >
      {Object.keys(groupedProperties).map((groupKey) => {
        const properties = groupedProperties[groupKey];
        const p1 = properties[0];
        const pType = properties.find((x) => x.type === "subject")
          ? "subject"
          : p1.type;
        return (
          <MapMarker
            lat={p1.lat}
            lng={p1.lng}
            onClick={(e) => onMarkerClick(e, properties)}
            key={groupKey}
            propertyType={pType}
            numProperties={properties.length}
          />
        );
      })}
    </GoogleMapReact>
  );
};
